<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="businessDetailGoodsInfo.products" border style="width: 100%">
        <el-table-column prop="productId" label="商品ID" align="center"></el-table-column>
        <el-table-column prop="categoryName" label="商品分组" align="center"></el-table-column>
        <el-table-column prop="prodName" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="shName" label="仓库" align="center"></el-table-column>
        <el-table-column prop="sales" label="销量" align="center"></el-table-column>
        <el-table-column prop="stock" label="库存" align="center"></el-table-column>
        <el-table-column prop="defaultSpecValue.price" label="价格" align="center"></el-table-column>
        <el-table-column prop="sort" label="排序" align="center"></el-table-column>
        <el-table-column prop="stateName" label="状态" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openProductDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="8"></el-col>
        <el-col :span="16" class="text-right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    businessDetailGoodsInfo: {
      type: Object,
      default: () => ({
        products: [],
        link: ''
      })
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    _openProductDetail(product) {
      window.open(`/#/pages/goods/productDetail?productId=${product.productId}`)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.$emit('page-change', val, this.pageSize)
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 15px;
}
.text-right {
  text-align: right;
}
</style>